import { FileStatus, FileOwnerRef, UploadSummary } from './types';

/**
 * @description Define la estructura de un archivo adjunto en la aplicación, que incluye información como el ID del archivo, su nombre, tipo MIME, tamaño, estado de carga y cualquier error asociado.
 * - Esto permite gestionar y mostrar los archivos adjuntos de manera consistente en la interfaz de usuario, facilitando la experiencia del usuario al interactuar con archivos multimedia.
 */
export interface AttachedFile {
  id?: string;
  remoteId?: string;
  key?: string;
  name: string;
  downloadName?: string;
  src?: string;
  mimeType?: string;
  size?: number;
  status: FileStatus;
  error?: string | null;
  owner?: FileOwnerRef;
  isProofOfPayment?: boolean; // Indicador de si el archivo es un comprobante de pago
  uploadedBy?: string; // Usuario que subió el archivo
  mailSent?: boolean; // Indicador de si se ha enviado un correo relacionado con este archivo
  mailSentBy?: string; // Usuario que envió el correo relacionado con este archivo
  mailSentByEmail?: string; // Correo del usuario que envió el correo relacionado con este archivo
  mailSentAt?: string; // Fecha de envío del correo relacionado con este archivo
  isDeleted?: boolean; // Indicador de si el archivo ha sido eliminado
  toEmails?: string[];
}

/**
 * @description Define la estructura del resultado de una operación de carga de archivos, que incluye la lista de archivos adjuntos resultantes, un indicador de si hubo cambios, si se cargaron archivos, las claves de los archivos eliminados y un resumen de la operación.
 * - Esto permite manejar y mostrar los resultados de las operaciones de carga de archivos de manera clara y estructurada, proporcionando información útil para la gestión de archivos multimedia en la aplicación.
 */
export interface UploaderResult {
  files: AttachedFile[];
  changed: boolean;
  uploaded: boolean;
  deletedKeys: string[];
  summary: UploadSummary;
  action?: 'close' | 'open-email';
  selectedProofOfPaymentFile?: AttachedFile;
}
